<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <!-- <router-link class="btn btn-sm" :to="{ name: 'SNMPList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link> -->
                Reset Audra
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Reset</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="Reset">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header py-3">
                <!-- <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3> -->
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">

                    <div class="form-group required">
                      <label class="control-label">MAC</label>
                      <input
                        type="text"
                        id="mac"
                        name="mac"
                        v-model="value.mac"
                        v-validate.lazy="{required: true, regex: /^(?:[0-9A-Fa-f]{2}[:-]){5}(?:[0-9A-Fa-f]{2})$/}"
                        class="form-control mac"
                        placeholder="mac"
                      />
                      <div class="help text-danger" v-show="errors.has('mac')">
                        {{ errors.first("mac") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Email</label>
                      <input
                        type="text"
                        id="email"
                        name="email"
                        v-model="value.email"
                        v-validate.lazy="'required|email'"
                        class="form-control email"
                        placeholder="email"
                      />
                      <div class="help text-danger" v-show="errors.has('email')">
                        {{ errors.first("email") }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" class="btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "Reset",
  metaInfo: {
    title: "Reset Audra | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/audra_reset";
          api_url += "?userAccountId=" + LocalStorage.get("accountId");
          let method = "POST";

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
            //   _this.$router.push({ name: "SNMPList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    async initialize() {
      this.is_loading = true;

      this.value.accountId = this.organizationId;

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>
